export default "__VITE_PUBLIC_ASSET__91bb4085__"